import type { DemoScenarioResolved } from 'tio-data/demo/types';
import type { DemoFixtureIdentity, DemoProductConfig, DemoScenario } from 'tio-employee/demo/types';
import {
  buildEmployeeTasActivitySearchMatchers,
  buildInProgressTasFetchMatchers,
  buildInProgressTasMatchers,
  buildTasSharedFetchMatchers,
} from 'tio-employee/demo/products/tas-fixtures';

/** TAS reads follow the selected payment model and persona; First Login has no progress. */
export function buildTasDemo(
  config: Extract<DemoProductConfig, { kind: 'tas' }>,
  scenario: DemoScenario,
  identity: DemoFixtureIdentity
): DemoScenarioResolved {
  const activityMatchers = buildEmployeeTasActivitySearchMatchers(
    identity,
    config.scenarioId,
    config.taPaymentModelId,
    config.benefitsMaxedOut
  );
  const firstLogin = scenario.role === 'employee' && scenario.persona === 'first-login';
  return {
    matchers: [
      ...activityMatchers,
      ...buildInProgressTasMatchers(identity, config.taPaymentModelId, {
        includeApprovalQueue: scenario.role !== 'employee',
        firstLogin,
      }),
    ],
    seed: [],
    fetchMatchers: [
      ...buildTasSharedFetchMatchers({ benefitsMaxedOut: config.benefitsMaxedOut, firstLogin }),
      ...buildInProgressTasFetchMatchers(identity, config.taPaymentModelId, firstLogin),
    ],
  };
}
